function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';
import { createClassNames } from 'react-instantsearch-dom';
import GoogleMapsContext from "./GoogleMapsContext.js";
import { LatLngPropType, BoundingBoxPropType } from "./propTypes.js";
var cx = createClassNames('GeoSearch');
var GoogleMaps = /*#__PURE__*/function (_Component) {
  _inherits(GoogleMaps, _Component);
  var _super = _createSuper(GoogleMaps);
  function GoogleMaps() {
    var _this;
    _classCallCheck(this, GoogleMaps);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "isUserInteraction", true);
    _defineProperty(_assertThisInitialized(_this), "isPendingRefine", false);
    _defineProperty(_assertThisInitialized(_this), "listeners", []);
    _defineProperty(_assertThisInitialized(_this), "mapRef", /*#__PURE__*/createRef());
    _defineProperty(_assertThisInitialized(_this), "state", {
      isMapReady: false
    });
    _defineProperty(_assertThisInitialized(_this), "setupListenersWhenMapIsReady", function () {
      _this.listeners = [];
      _this.setState({
        isMapReady: true,
        value: {
          google: _this.props.google,
          instance: _this.instance
        }
      });
      var onChange = function onChange() {
        if (_this.isUserInteraction) {
          _this.props.onChange();
        }
      };
      _this.listeners.push(_this.instance.addListener('center_changed', onChange));
      _this.listeners.push(_this.instance.addListener('zoom_changed', onChange));
      _this.listeners.push(_this.instance.addListener('dragstart', onChange));
      _this.listeners.push(_this.instance.addListener('idle', function () {
        if (_this.isUserInteraction) {
          _this.props.onIdle({
            instance: _this.instance
          });
        }
      }));
    });
    return _this;
  }
  _createClass(GoogleMaps, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        google = _this$props.google,
        mapOptions = _this$props.mapOptions;
      this.instance = new google.maps.Map(this.mapRef.current, _objectSpread({
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        clickableIcons: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_TOP
        }
      }, mapOptions));
      this.listeners.push(google.maps.event.addListenerOnce(this.instance, 'idle', this.setupListenersWhenMapIsReady));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      var _this$props2 = this.props,
        google = _this$props2.google,
        initialZoom = _this$props2.initialZoom,
        initialPosition = _this$props2.initialPosition,
        boundingBox = _this$props2.boundingBox,
        boundingBoxPadding = _this$props2.boundingBoxPadding,
        shouldUpdate = _this$props2.shouldUpdate;
      if (!shouldUpdate()) {
        return;
      }
      if (boundingBox) {
        this.lockUserInteraction(function () {
          var oldBounds = _this2.instance.getBounds();

          // south west and north east are swapped
          var newBounds = new google.maps.LatLngBounds(boundingBox.southWest, boundingBox.northEast);
          if (!newBounds.equals(oldBounds)) {
            _this2.instance.fitBounds(newBounds, boundingBoxPadding);
          }
        });
      } else {
        this.lockUserInteraction(function () {
          _this2.instance.setZoom(initialZoom);
          _this2.instance.setCenter(initialPosition);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.listeners.forEach(function (listener) {
        listener.remove();
      });
      this.listeners = [];
    }
  }, {
    key: "lockUserInteraction",
    value: function lockUserInteraction(functionThatAltersTheMapPosition) {
      this.isUserInteraction = false;
      functionThatAltersTheMapPosition();
      this.isUserInteraction = true;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var isMapReady = this.state.isMapReady;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('')
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.mapRef,
        className: cx('map')
      }), isMapReady && /*#__PURE__*/React.createElement(GoogleMapsContext.Provider, {
        value: this.state.value
      }, children));
    }
  }]);
  return GoogleMaps;
}(Component);
_defineProperty(GoogleMaps, "propTypes", {
  google: PropTypes.object.isRequired,
  initialZoom: PropTypes.number.isRequired,
  initialPosition: LatLngPropType.isRequired,
  mapOptions: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onIdle: PropTypes.func.isRequired,
  shouldUpdate: PropTypes.func.isRequired,
  boundingBox: BoundingBoxPropType,
  boundingBoxPadding: PropTypes.number,
  children: PropTypes.node
});
export default GoogleMaps;